module.exports = __webpack_public_path__ + "static/media/bil1_img5.96b13e31.jpg";